// @flow

export const pendingStatusSelector = (state: StoreType, component: string): any => state.pendingStatus[component];
export const currentConversationLoadingStatusSelector = (state: StoreType): any => state.pendingStatus.currentConversationLoadingStatus;
export const visitorContactCreationStatusSelector = (state: StoreType): any => state.pendingStatus.visitorContactCreationStatus;
export const currentFallbackSettingLoadingStatusSelector = (state: StoreType): any => state.pendingStatus.currentFallbackSettingLoadingStatus;
export const currentSavingStatusSelector = (state: StoreType): any => state.pendingStatus.currentSavingStatus;
